export const LOADING="LOADING";
export const TASK_DATA="TASK_DATA";
export const DASHBOARD="DASHBOARD";
export const ACTIVITIES="ACTIVITIES";
export const FETCH_CURRENT_USER="FETCH_CURRENT_USER";
export const FETCH_AUTH_PRIVILEGE="FETCH_AUTH_PRIVILEGE";
export const FETCH_USERS="FETCH_USERS";
export const FETCH_USERS_DATA="FETCH_USERS_DATA";
export const SAVE_USER="SAVE_USER";
export const UPDATE_USER="UPDATE_USER";
export const FETCH_ROLES="FETCH_ROLES";
export const FETCH_TASKS="FETCH_TASKS";
export const FETCH_TASK="FETCH_TASK";
export const SET_TASK="SET_TASK";
export const SAVE_TASK="SAVE_TASK";
export const MODAL_ACTION="MODAL_ACTION";
export const ADD_TASK_COMMENT="ADD_TASK_COMMENT";
export const UPDATE_TASK_FILE="UPDATE_TASK_FILE";
export const UPDATE_TASK_STATUS="UPDATE_TASK_STATUS";
export const LOGOUT_ACTION="LOGOUT_ACTION";
export const SET_USER_PROFILE="SET_USER_PROFILE";
export const FETCH_ORGANISATIONS="FETCH_ORGANISATIONS";
export const FETCH_PROGRAMS="FETCH_PROGRAMS";
export const FETCH_SUBSCRIPTION="FETCH_SUBSCRIPTION";